import React from 'react';
import './CommentConflictPopup.css';

function CommentConflictPopup({ existingComment, newComment, newRating, onSubmit, onCancel }) {
    return (
        <div className="conflict-popup-overlay">
            <div className="conflict-popup">
                <h3>You've Already Commented</h3>
                <p className="conflict-message">
                    Would you like to update your previous comment with the new one?
                </p>

                <div className="comment-comparison">
                    <div className="existing-comment-section">
                        <h4>Your Previous Comment</h4>
                        <div className="comment-preview">
                            <div className="comment-rating">
                                Rating: {'⭐'.repeat(existingComment.rating)}
                            </div>
                            <p className="comment-text">{existingComment.comment_text}</p>
                            <p className="comment-date">
                                Posted: {new Date(existingComment.comment_date).toISOString().split('T')[0]}
                            </p>
                        </div>
                    </div>

                    <div className="new-comment-section">
                        <h4>New Comment</h4>
                        <div className="comment-preview">
                            <div className="comment-rating">
                                Rating: {'⭐'.repeat(newRating)}
                            </div>
                            <p className="comment-text">{newComment}</p>
                        </div>
                    </div>
                </div>

                <div className="conflict-popup-actions">
                    <button className="btn-submit" onClick={onSubmit}>
                        Update Comment
                    </button>
                    <button className="btn-cancel" onClick={onCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CommentConflictPopup;
